<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4jIsiK/tc-custom/9781609453718.jpg?1726617332079" alt="This image is the cover for the book Beach at Night"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beach at Night
      </h1>
      <p class="bookDescription body article font2">
        <b>A “beautifully written” dark fable from a doll’s point of view—by the <i>New York Times</i>–bestselling author of <i>The Lost Daughter</i> and the Neapolitan Novels (<i>The Washington Post</i>).</b><br/>  <br/><b>One of NPR’s Best Books of the Year.</b><br/>  <br/> Readers of Elena Ferrante’s <i>The Lost Daughter</i> may recall the little doll—lost or stolen—around which that novel revolves. Here, Ferrante retells the tale from the doll’s perspective.<br/>  <br/> Celina is having a terrible night, one full of jealousy for the new kitten, Minù; feelings of abandonment and sadness; misadventures at the hands of the beach attendant; and dark dreams. But she will be happily found by Mati, her child, once the sun rises . . .<br/>  <br/> “Everyone should read anything with Ferrante’s name on it.” —<i>The Boston Globe</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elena Ferrante, Mara Cerri, Ann Goldstein
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Europa Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7d5b0555